import { validateMandatoryCallFormFields } from '../../../../../_helper/mandatoryFieldRules';
import { isMandatorySchemaField } from '../../../../../_helper/fieldAccess';

const FIELD_NAME_MAP = {
    'customer.clientname': 'clientName',
    'customers.clientname': 'clientName',
    'customer.companyname': 'companyName',
    'customers.companyname': 'companyName',
    'customer.identitynumber': 'tcid',
    'customers.identitynumber': 'tcid',
    'customer.taxnumber': 'taxNumber',
    'customers.taxnumber': 'taxNumber',
    'customer.crsnumber': 'crsNumber',
    'customers.crsnumber': 'crsNumber',
    'customer.address': 'address',
    'customers.address': 'address',
    'customer.district': 'district',
    'customers.district': 'district',
    'customer.phones.phone': 'phoneNumber',
    'customers.phones.phone': 'phoneNumber',
    'customers.phones.phonedescription': 'phoneDescription',
    'customer.phones.phonedescription': 'phoneDescription',
    'customer.emails.email': 'email',
    'customers.emails.email': 'email',
    'customer.ibans.iban': 'iban',
    'customers.ibans.iban': 'iban',
    'customer.agent': 'agentId',
    'customers.agent': 'agentId',
    'customers.reference': 'reference',
    'customer.reference': 'reference',
    'customers.contractrate': 'customerContractRate',
    'customer.contractrate': 'customerContractRate',
    'customers.enforcementattorneyfeesharerate': 'customerEnforcementAttorneyFeeShareRate',
    'customers.judgmentattorneyfeesharerate': 'customerJudgmentAttorneyFeeShareRate',
    'customers.payinteresttocustomer': 'customerPayInterestToCustomer',
    'licenseplate.licenseplatenumber': 'licensePlate',
    'licenseplates.licenseplatenumber': 'licensePlate',
    'licenseplate.carchassisnumber': 'chassisNumber',
    'licenseplates.carchassisnumber': 'chassisNumber',
    'licenseplate.carbrand': 'carBrand',
    'licenseplates.carbrand': 'carBrand',
    'licenseplate.carmodel': 'carModel',
    'licenseplates.carmodel': 'carModel',
    'licenseplate.caryear': 'carYear',
    'licenseplates.caryear': 'carYear',
    'licenseplate.trafficinsurancepolicy.trafficinsuranceprovider': 'trafficInsurancePolicy.trafficInsuranceProvider',
    'licenseplates.trafficinsurancepolicy.trafficinsuranceprovider': 'trafficInsurancePolicy.trafficInsuranceProvider',
    'licenseplate.cascoinsurancepolicy.cascoinsuranceprovider': 'cascoInsurancePolicy.cascoInsuranceProvider',
    'licenseplates.cascoinsurancepolicy.cascoinsuranceprovider': 'cascoInsurancePolicy.cascoInsuranceProvider',
    'accident.accidentdate': 'accidentDate',
    'accidents.accidentdate': 'accidentDate',
    'accident.estimateddepreciationamount': 'estimatedDepreciationAmount',
    'accidents.estimateddepreciationamount': 'estimatedDepreciationAmount',
    'accident.damageamount': 'damageAmount',
    'accidents.damageamount': 'damageAmount',
    'accident.counterpartytype': 'counterpartyType',
    'accidents.counterpartytype': 'counterpartyType',
    'accident.counterpartyidentificationnumber': 'counterpartyIdentificationNumber',
    'accidents.counterpartyidentificationnumber': 'counterpartyIdentificationNumber',
    'accident.counterpartytaxnumber': 'counterpartyTaxNumber',
    'accidents.counterpartytaxnumber': 'counterpartyTaxNumber',
    'accident.counterpartycarowner': 'counterpartyCarOwner',
    'accidents.counterpartycarowner': 'counterpartyCarOwner',
    'accident.counterpartylicenseplatenumber': 'counterpartyLicensePlateNumber',
    'accidents.counterpartylicenseplatenumber': 'counterpartyLicensePlateNumber',
    'accident.counterpartytrafficinsurancepolicy.trafficinsuranceprovider': 'counterpartyTrafficInsurancePolicy.trafficInsuranceProvider',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsuranceprovider': 'counterpartyTrafficInsurancePolicy.trafficInsuranceProvider',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsurancenumber': 'counterpartyTrafficInsurancePolicy.trafficInsuranceNumber',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsurancestart': 'counterpartyTrafficInsurancePolicy.trafficInsuranceStart',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsuranceexpiry': 'counterpartyTrafficInsurancePolicy.trafficInsuranceExpiry',
    'accident.counterpartycascoinsurancepolicy.cascoinsuranceprovider': 'counterpartyCascoInsurancePolicy.cascoInsuranceProvider',
    'accidents.counterpartycascoinsurancepolicy.cascoinsuranceprovider': 'counterpartyCascoInsurancePolicy.cascoInsuranceProvider',
    'accident.ourfaultrate': 'ourFaultRate',
    'accidents.ourfaultrate': 'ourFaultRate',
    'accident.counterpartyfaultrate': 'counterpartyFaultRate',
    'accidents.counterpartyfaultrate': 'counterpartyFaultRate',
    'accident.appointedexperts': 'appointedExperts',
    'accidents.appointedexperts': 'appointedExperts',
    'powerofattorney.poanumber': 'powerOfAttorneyNumber',
    'powersofattorney.poanumber': 'powerOfAttorneyNumber',
    'powerofattorney.poadate': 'powerOfAttorneyDate',
    'powersofattorney.poadate': 'powerOfAttorneyDate',
    'powerofattorney.notaryofpoa': 'notaryNumber',
    'powersofattorney.notaryofpoa': 'notaryNumber',
    'powerofattorney.contractrate': 'contractRate',
    'powersofattorney.contractrate': 'contractRate',
    'powersofattorney.ispoatimelimited': 'isPowerOfAttorneyTimed',
    'powersofattorney.islicenseplateslimited': 'isLicensePlatesLimited',
    'powersofattorney.poaoriginalarrived': 'hasOriginalArrived',
    'accidentfile.fileopendate': 'registrationDate',
    'accidentfiles.fileopendate': 'registrationDate',
    'accidentfile.jobtobeworked': 'jobToBeWorked',
    'accidentfiles.jobtobeworked': 'jobToBeWorked',
    'accidentfile.whoseinsurance': 'whoseInsurance',
    'accidentfiles.whoseinsurance': 'whoseInsurance',
    'accidentfile.documentrequestdate': 'documentRequestDate',
    'accidentfiles.documentrequestdate': 'documentRequestDate',
    'accidentfile.documentrequeststatus': 'documentRequestStatus',
    'accidentfiles.documentrequeststatus': 'documentRequestStatus',
    'accidentfile.documentreceiveddate': 'documentReceivedDate',
    'accidentfiles.documentreceiveddate': 'documentReceivedDate',
};

const resolveValueByPath = (source, path) => {
    const keys = path.split('.');
    let value = source;
    let isValid = true;

    for (const key of keys) {
        if (value === null || value === undefined) {
            isValid = false;
            break;
        }

        if (!Object.prototype.hasOwnProperty.call(value, key) || value[key] === undefined || value[key] === null) {
            if (key !== keys[keys.length - 1]) {
                isValid = false;
                break;
            }
            value = value[key];
        } else {
            value = value[key];
        }
    }

    return { value, isValid };
};

export const validateRequiredFieldsByPermissions = ({ fieldPermissions, formData }) => {
    const errors = {};

    fieldPermissions.forEach((permission) => {
        if (!permission.required || !isMandatorySchemaField(permission.fieldName)) {
            return;
        }

        const mappedField = FIELD_NAME_MAP[permission.fieldName] || permission.fieldName;
        const mappedResult = resolveValueByPath(formData, mappedField);
        const originalResult = resolveValueByPath(formData, permission.fieldName);
        const { value, isValid } = mappedResult.isValid ? mappedResult : originalResult;
        const isEmpty = value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0);

        if (!isValid || isEmpty) {
            errors[mappedField] = 'Bu alan zorunludur.';
        }
    });

    return errors;
};

export const validateCallFormRequiredFields = ({ formData, currentFormState, action, insuranceCompanies }) => ({
    ...validateMandatoryCallFormFields(formData, { currentStateCode: currentFormState, action, insuranceCompanies }),
});
